import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { atcClassificationsActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class AtcClassifications extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newAtcClassification, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Classificações ATC'}
          classes={classes}
          newResource={newAtcClassification}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'classificacoes_atc'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.atcClassifications.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(atcClassificationsActions.openModal())
    },
    closeModal: () => {
      dispatch(atcClassificationsActions.closeModal())
    },
    newAtcClassification: atcClassification => {
      dispatch(atcClassificationsActions.newFormAtcClassification(atcClassification))
    },
    resetState: () => {
      dispatch(atcClassificationsActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(AtcClassifications))



// WEBPACK FOOTER //
// ./src/containers/AtcClassifications/index.js